import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({ name: 'imgResize', pure: true })
export class ImageResizePipe implements PipeTransform {
  resizeRegEx: RegExp;
  resizeUrl: string;

  constructor() {
    this.resizeRegEx = /https:\/\/pinploy.+?\//i;
    this.resizeUrl = environment.resizeUrl.endsWith('/')
      ? environment.resizeUrl.substring(0, environment.resizeUrl.length - 1)
      : environment.resizeUrl;
  }

  /**
   * @param url: the direct url to the image, hosted in the bucket
   * @param width: the desired width
   * @param height: the desired height
   */
  transform(url: string, width: number, height: number): string {
    if (!url) return url;
    return url.replace(
      this.resizeRegEx,
      `${this.resizeUrl}/${width}x${height}/`,
    );
  }
}
